
import React from 'react';

const Disk = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='33'
			height='32'
			fill='none'
			viewBox='0 0 33 32'
		>
			<g clipPath='url(#clip0_3082:66250)'>
				<g fill='#2d2d2d' clipPath='url(#clip1_3082:66250)'>
					<path d='M16.5 28c-6.62 0-12-5.38-12-12s5.38-12 12-12 12 5.38 12 12-5.38 12-12 12zm0-22c-5.51 0-10 4.49-10 10s4.49 10 10 10 10-4.49 10-10-4.49-10-10-10z'>
					</path>
					<path d='M16.5 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'></path>
					<path d='M16.5 21c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3z'></path>
					<path d='M16.5 25c-4.96 0-9-4.04-9-9h2c0 3.86 3.14 7 7 7v2zM25.5 16h-2c0-3.86-3.14-7-7-7V7c4.96 0 9 4.04 9 9z'></path>
				</g>
			</g>
			<defs>
				<clipPath id='clip0_3082:66250'>
					<path fill='#fff' d='M0 0H32V32H0z' transform='translate(.5)'></path>
				</clipPath>
				<clipPath id='clip1_3082:66250'>
					<path
						fill='#fff'
						d='M0 0H24V30H0z'
						transform='translate(4.5 4)'
					></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default Disk;
